export const userSettingsFieldNames = {
  canChangePassword: 'canChangePassword',
  canManageLicenses: 'canManageLicenses',
  canManageClassroom: 'canManageClassroom',
  canManageParent: 'canManageParent',
  suppressEmails: 'suppressEmails',
  canManageSelf: 'canManageSelf',
  canManageStudent: 'canManageStudent',
  canChangeStudentPassword: 'canChangeStudentPassword',
};
